class ShouldNotDestroy {}

export default ShouldNotDestroy;
